<template>
  <div id="app">
    <navbar />
    <router-view v-if="!isMobile || overrideMobile"/>
    <div class="section content" v-else>
      <h4>
        Sorry, no mobile support yet 😞
      </h4>
    </div>
    <div class="footer-buttons">
    </div>
  </div>
</template>

<script>

import Navbar from '@/components/Navbar.vue'

export default {
  name: 'App',
  components: {
    'navbar': Navbar,
  },
  props: [
  ],
  data () {
    return {
    }
  },
  mounted () {

  },
  computed: {
    isMobile () {
      return window.navigator.userAgent.toLowerCase().includes('mobi')
    }
  },

}

</script>

<style lang="sass">

.loading-overlay .loading-icon:after
  border-left-color: #ffdd57 !important
  border-bottom-color: #ffdd57 !important

</style>
